import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Error = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.33691 22.33789"
      width={size}
      height={size}
    >
      <title>{iconTitle}</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g id="Welcome">
            <g id="medis_styleguide" data-name="medis styleguide">
              <g id="Group-2">
                <g id="Oval-3">
                  <path
                    fill={iconColor}
                    d="M11.16895,22.33789a11.16895,11.16895,0,1,1,11.168-11.16895A11.18208,11.18208,0,0,1,11.16895,22.33789ZM11.16895,1a10.16895,10.16895,0,1,0,10.168,10.16895A10.18015,10.18015,0,0,0,11.16895,1Z"
                  />
                </g>
                <g id="Combined-Shape">
                  <polygon
                    fill={iconColor}
                    points="11.168 10.606 7.054 6.491 6.472 7.073 10.587 11.188 6.309 15.466 6.891 16.048 11.168 11.77 15.446 16.048 16.028 15.466 11.75 11.188 15.865 7.073 15.283 6.491 11.168 10.606"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Error.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Error.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Error);
